export const en = {
    'action-delete': 'Delete',
    'action-delete-thread': 'Delete a discussion',
    'action-discussion': 'Start a discussion',
    'action-edit': 'Edit',
    'action-expand-thread-comments': [ '{{count}} more message', '{{count}} more messages', '{{count}} more messages', '{{count}} more messages' ],
    'action-reply': 'Reply',
    'error-add-title': 'Couldn\'t add comment',
    'error-delete-title': 'Couldn\'t delete comment',
    'error-edit-title': 'Couldn\'t save comment',
    'error-empty-text': 'There are no comments on this page yet.',
    'error-empty-title': 'There\'s nothing here',
    'error-get-title': 'Couldn\'t load comments',
    placeholder: 'Add comment',
    'placeholder-thread': 'Add an answer',
    title: 'Comments'
};
